import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const dashboardRoute: InvariantJiraRoute = {
	name: 'dashboard',
	path: '/secure/Dashboard.jspa',
};
